import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { ASSETS } from "../../data/site";
import { useSignup } from "../SignupProvider";

const LINKS = [
  { label: "Features", href: "/#features" },
  { label: "How it works", href: "/#how-it-works" },
  { label: "Privacy", href: "/#privacy" },
  { label: "FAQ", href: "/#faq" },
];

export const Navbar = () => {
  const { openSignup } = useSignup();
  const [scrolled, setScrolled] = useState(false);
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-[#2F5E43]/10 bg-[#FBFBF9]/80 backdrop-blur-xl"
          : "border-b border-transparent bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
        <Link to="/" className="flex items-center gap-2.5" data-testid="navbar-logo">
          <img src={ASSETS.logoIcon} alt="SisterSafe" className="h-9 w-9 object-contain" />
          <span className="font-heading text-xl font-semibold tracking-tight text-[#111E16]">
            SisterSafe
          </span>
        </Link>

        <nav className="hidden items-center gap-9 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-[#4A5F52] transition-colors hover:text-[#2F5E43]"
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <button
            onClick={() => openSignup("beta")}
            className="text-sm font-medium text-[#2F5E43] transition-colors hover:text-[#244A34]"
            data-testid="navbar-beta-btn"
          >
            Become a Beta Tester
          </button>
          <button
            onClick={() => openSignup("waitlist")}
            className="rounded-full bg-[#2F5E43] px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#244A34]"
            data-testid="navbar-waitlist-btn"
          >
            Join the Waitlist
          </button>
        </div>

        <button
          className="text-[#2F5E43] md:hidden"
          onClick={() => setMobile((v) => !v)}
          data-testid="navbar-mobile-toggle"
          aria-label="Menu"
        >
          {mobile ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {mobile && (
        <div className="border-t border-[#2F5E43]/10 bg-[#FBFBF9]/95 px-6 py-5 backdrop-blur-xl md:hidden">
          <nav className="flex flex-col gap-4">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setMobile(false)}
                className="text-base font-medium text-[#4A5F52]"
              >
                {l.label}
              </a>
            ))}
            <button
              onClick={() => {
                setMobile(false);
                openSignup("waitlist");
              }}
              className="mt-2 rounded-full bg-[#2F5E43] px-5 py-3 text-center font-medium text-white"
              data-testid="navbar-mobile-waitlist"
            >
              Join the Waitlist
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};
